import { createSlice } from "@reduxjs/toolkit";

export const roleInfoData = createSlice({
  name: "roleInfoDetails",
  initialState: null,
  reducers: {
    setRoleInfoData: (state, action) => {
      return (state = action.payload);
    },
  },
});

export const { setRoleInfoData } = roleInfoData.actions;

export default roleInfoData.reducer;
